/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'at.tastetest.game.list'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  leagues: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<LeagueView>((() => leagueView) as any),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type LeagueView = {
  $type?: 'at.tastetest.game.list#leagueView'
  id: string
  name: string
  testType: string
  memberCount: number
  maxPlayers: number
  isAdmin: boolean
}

export type { LeagueView }

const leagueView = /*#__PURE__*/ l.typedObject<LeagueView>(
  $nsid,
  'leagueView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.string(),
    name: /*#__PURE__*/ l.string(),
    testType: /*#__PURE__*/ l.string(),
    memberCount: /*#__PURE__*/ l.integer(),
    maxPlayers: /*#__PURE__*/ l.integer(),
    isAdmin: /*#__PURE__*/ l.boolean(),
  }),
)

export { leagueView }
